module.exports = __webpack_public_path__ + "img/no-lot.20bc3398.svg";